import { RgAffectsGeometry as e } from "@project-rouge/rg-core";
function n(t) {
  if (!t.parent || !t.parent.userData.rg)
    return !1;
  const r = t.parent;
  return e[r.userData.type].includes(t.userData.type);
}
export {
  n as affectsParent
};
//# sourceMappingURL=index.js.map
